// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"96287b34","247":"f499ba90","513":"4bc721b6","665":"acd8391c","706":"773da0a0"}[chunkId] + ".chunk.js";
};